<template>
  <div class="ml-0 ml-md-3">
       <h4 v-html="getTitle" class="title-small text-uppercase letter-spacing-3 black-text font-weight-600"></h4> 

    <div class="mt-2" v-html="getDescription"></div>
  </div>
</template>

<script>
export default {
  name: "ShopVoucherDescriptionPanel",
  props: ["getSelectedItem"],
  computed: {
    getSelectedLanguage() {
      return this.$store.getters.getLanguage;
    },
    getLanguageItem: function() {
      return this.$store.getters.getLanguageStrings;
    },
    getTitle() {
      return this.getSelectedItem.title;
    },
    getDescription() {
      return this.getSelectedItem.description;
    }
  },
  beforeMount() {   
  }
};
</script>
